
export const SET_TOP_BANNER = 'banners.top.set';
export const setTopBanner = component => ({ type: SET_TOP_BANNER, component });

export const SET_BOTTOM_BANNER = 'banners.bottom.set';
export const setBottomBanner = component => ({ type: SET_BOTTOM_BANNER, component });

export const CLOSE_TOP_BANNER_MSG = 'banners.top.closeMsg';
export const closeTopBannerMsg = id => ({ type: CLOSE_TOP_BANNER_MSG, id });
